import { Injectable } from '@angular/core';
import { SecurityService } from '../../../Core/Security/security.service';
import { ConfigService } from '../../../Core/Abstract/config.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LogService } from '../../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';

@Injectable()
export class OnboardFilesService extends SecurityService{

     constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService) {
        super(http,configService,eventsEmitterService, router ,logger);
    }

    submit(bean:any): Observable<any>{
        let serviceUrl = this.baseUrl + 'OnboardFilesService/submit?';
        return this.http.post<any>(serviceUrl,bean).pipe(map(response => {return response;}));
    }

    save(bean:any): Observable<any>{
        let serviceUrl = this.baseUrl + 'OnboardFilesService/save?';
        return this.http.post<any>(serviceUrl,bean).pipe(map(response => {return response;}));
    }

    getDocumentList(companyType:any , isAdmin:any): Observable<any>{
        let serviceUrl = this.baseUrl + 'FileUploadService/getDocumentList?companyType='+companyType + '&isAdmin=' + isAdmin;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
}